import { parseJson } from './api';
import { updateTermsOfUse } from '../api/vsApi';

export const showOptionalTermsOfUse = () => {
    return {
        type: "SHOW_OPTIONAL_TERMS_OF_USE",
    }
}

export const showTermsOfUse = () => {
    return {
        type: "SHOW_TERMS_OF_USE",
    }
}

export const hideTermsOfUse = () => {
    return {
        type: "HIDE_TERMS_OF_USE",
    }
}

export const setAcceptedTermsOfUseVersion = (version) => {
    return {
        type: "SET_ACCEPTED_TERMS_OF_USE_VERSION",
        version,
    }
}

export const setError = (errorMessage) => {
    return {
        type: "SET_ERROR",
        errorMessage,
    }
}

export const updateTermsOfUseVersion = (acceptedTermsVersion) => {
    return function(dispatch, getState) {
        let deviceId = getState().api.deviceId;
        let language = getState().language.language;
        let authorizationToken = getState().auth.authorizationToken;
        let headers;
        let status;
        return updateTermsOfUse(acceptedTermsVersion, language, deviceId, authorizationToken)
        .then(response => {
            status = response.status;
            headers = response.headers;
            return parseJson(response, language);
        })
        .then(response => {
            let contentType = headers.get("content-type");
            let length = headers.get("content-length");
            if (status === 200 && length !==0 && contentType!=="application/json;charset=UTF-8"){
                dispatch(setAcceptedTermsOfUseVersion(acceptedTermsVersion));
            } 
        })
        .catch(err => {
            dispatch(setError(err.message))
        });
    }
}
